import { render, staticRenderFns } from "./DBtnIcon.vue?vue&type=template&id=451ebc8c"
import script from "./DBtnIcon.vue?vue&type=script&lang=js"
export * from "./DBtnIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports